import { Address } from "./Address";
import { OrderVariant } from "./OrderVariant";
import { SubState } from "./SubState";
import { User } from "./User";
import { AsyncResource } from "./utilityTypes";

export type OrderType =
  | "pre-order"
  | "on-demand"
  | "from-inventory"
  | "to-inventory";

export type OrderStatus =
  | "draft"
  | "submitted"
  | "approved"
  | "error"
  | "canceled";

interface StatusSubmitted {
  status: "submitted" | "approved";
  submittedAt: Date;
}
interface StatusApproved {
  status: "approved";
  approvedAt: Date;
}
interface StatusOther {
  status: "draft" | "error" | "canceled";
  submittedAt: null;
  approvedAt: null;
}

type OrderStatusWithDates = StatusSubmitted | StatusApproved | StatusOther;

interface OrderToInventory {
  type: "to-inventory";
  /** to-inventory order types will never change */
  orderingType: "to-inventory";
  address: null | Address;
  subState?: SubState;
}
interface OrderDefault {
  /**
   * may change to "from-inventory" if po is fulfilled with inventory
   * use orderingType for displaying the original type of the order.
   */
  type: Exclude<OrderType, "to-inventory">;
  /** original type of the order placed by the user */
  orderingType: Exclude<OrderType, "to-inventory">;
  address: Address;
}

type OrderTypeWithAddress = OrderToInventory | OrderDefault;
interface OrderSharedAttributes {
  id: string;
  totalQuantity: number;

  totalActualCost: string;
  totalActualShippingCost: string;
  totalBeaconCost: string;
  totalEstimatedCost: string;
  totalEstimatedShippingCost: string;
  totalEstimatedTax: string;

  billableTotalActualCost: string;
  billableTotalActualShippingCost: string;
  billableTotalBeaconCost: string;
  billableTotalEstimatedCost: string;
  billableTotalEstimatedShippingCost: string;
  billableTotalEstimatedTax: string;

  isBrandFunded?: boolean;
  subjectToBudgeting: boolean;
  orderSetDistributorPurchaseOrderNumber: null | string;
  externalSapId: string | null;

  marketId: string | null;
  marketName: string | null;
  territoryName: string | null;
  territoryId: string | null;
  orderWindowName?: string;
  programNames: string[];
  notes: string | null;
  attn: string | null;
  user: User;
  orderVariants: OrderVariant[];
  brand: null;
  orderSet: AsyncResource<"order-set">;
}

export type Order = OrderSharedAttributes &
  OrderStatusWithDates &
  OrderTypeWithAddress;

export interface OrderPayload {
  type: OrderType;
  address: { type: "address"; id: string };
  orderSet: { type: "order-set"; id: string };
  relationshipNames: string[];
}

export enum OrderOrigin {
  Internal = "Internal",
  Distributor = "Distributor",
}
